import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicInput, BaasicButton } from 'core/components';
import _ from 'lodash';
import { toDate } from 'core/utils';

function TaskCommentTemplate({ taskCommentStore = true }) {
    const {
        form,
        comments
    } = taskCommentStore;

    return (
        <React.Fragment>
            <div className='form__group__label'>Comments</div>
            <div className='iputgroup u-mar--bottom--sml'>
                <div className='inputgroup--main'>
                    <BasicInput showLabel={false} showRequiredMark={false} showWarning={false} field={form.$('message')} />
                </div>
                <div className="inputgroup--aside">
                    <BaasicButton
                        type='submit'
                        className="btn btn--base btn--primary"
                        onClick={form.onSubmit}
                        rotate
                        icon={
                            form.submitting || form.validating
                                ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                : 'u-display--none'
                        }
                        label="Add"
                    />
                </div>
            </div>
            {comments.length > 0 && <div
                // className={`u-mar--bottom--sml ${scroll && 'task-comment__overlay'}`}
            >
                {_.map(comments, c => { 

                    return (
                        <div key={c.id} className={`message message--comment message--sml ${c.unRead && `is-unread`}`}>
                            <div className="flex flex--primary">
                                <code className="message--comment--name">{c.author.fullName}</code>
                                <label className="message--comment--time">{toDate(c.dateUpdated,true)}</label> 
                            </div> 
                            <p>{c.message}</p>
                        </div>
                    )
                })}
            </div>}
        </React.Fragment>
    );
    
}

TaskCommentTemplate.propTypes = {
    taskCommentStore: PropTypes.object,
    t: PropTypes.func,
    scroll:PropTypes.bool
};

export default defaultTemplate(TaskCommentTemplate);
